import { render, staticRenderFns } from "./Politica-privacidad.vue?vue&type=template&id=734e0126&scoped=true&"
import script from "./Politica-privacidad.vue?vue&type=script&lang=js&"
export * from "./Politica-privacidad.vue?vue&type=script&lang=js&"
import style0 from "./Politica-privacidad.vue?vue&type=style&index=0&id=734e0126&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e0126",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
